import "./ComboCourses.scss";
import CustomModal from "../../../../../../../custom_utilities/Modal/CustomModal";
import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  FINISH_LOADING,
  START_LOADING,
} from "../../../../../../../redux/ui/action_type";
import images from "../../../../../../../utilities/images/images";
import { Render } from "../../../../../../homepage/Render";
import VideoDrmPlayer from "../../../../../features/video_feature/video_feature_content_component/VideoDrmPlayer";
import userActivityActions from "../../../../../../../../src/redux/user_activity/action";
import { useHistory } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import Slider from "react-slick";

const ComboCourses = ({ handleClose, comboCoursesDetails }) => {
  const [comboCoursesData, setComboCoursesData] = useState(null);
  const [active, setActive] = useState("desc");
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const changeTab = (tab) => setActive(tab);

  const description =
    comboCoursesData?.PackageInstallmentDetails?.description || "";
  const truncatedDescription =
    description.length > 220
      ? description.substring(0, 220) + "..."
      : description;

  const whatsAppMessageSender = () => {
    const phoneNumber = parseInt(comboCoursesData?.motion_whatsapp_no);
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  useEffect(() => {
    if (comboCoursesDetails?.package_id) {
      fetchPackageData(comboCoursesDetails.package_id);
    }
  }, [comboCoursesDetails?.package_id]);

  const fetchPackageData = async (packageId) => {
    try {
      dispatch({ type: START_LOADING });

      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/user/package_detail_web?package_id=${packageId}`
      );

      const data = response.data?.data;
      setComboCoursesData(data);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: FINISH_LOADING });
    }
  };

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    speed: 3000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],
  };

  const setSubjectData = (data) => {
    dispatch(
      userActivityActions.setSubjectData({
        subjectId: data.sub_id,
        subjectName: data.sub_name,
        subjectIcon: data.icon,
      })
    );
    history.push("/subject_component");
  };

  return (
    <CustomModal isOpen={true} closeModal={handleClose} width="800px">
      <Fragment>
        <div className="user-dashboard-store-banner-inner-wrapper">
          <div className="store-banner-content-and-btn-wrapper">
            <div className="text">
              {comboCoursesData?.PackageInstallmentDetails?.package_name}
            </div>
            <img
              src={comboCoursesData?.PackageInstallmentDetails?.icon}
              alt="banner"
            />
            {comboCoursesData?.PackageInstallmentDetails?.thumbnail_tag && (
              <div
                className="new-label"
                style={{
                  backgroundColor:
                    comboCoursesData?.PackageInstallmentDetails?.tag_background,
                  color:
                    comboCoursesData?.PackageInstallmentDetails?.tag_textcolor,
                }}
              >
                {comboCoursesData?.PackageInstallmentDetails?.thumbnail_tag}
              </div>
            )}
          </div>
          <div className="tabs-container">
            <div className="tabs">
              <div
                className={`tab ${active === "desc" ? "active" : ""}`}
                onClick={() => changeTab("desc")}
              >
                <i className="icon description-icon"></i>
                Description
              </div>
              <div
                className={`tab ${active === "subjects" ? "active" : ""}`}
                onClick={() => changeTab("subjects")}
              >
                <i className="icon subjects-icon"></i>
                Subjects
              </div>
            </div>
            <div className="contact-icons">
              <div
                className="icon-button whatsapp"
                onClick={whatsAppMessageSender}
              >
                <img src={images.whatsaap} alt="WhatsApp" />
              </div>
              <div className="icon-button call">
                <a href={`tel:${comboCoursesData?.motion_mobile_no}`}>
                  <img src={images.phoneCall} alt="Call" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {active === "desc" && (
          <>
            <Render
              if={comboCoursesData?.PackageInstallmentDetails?.description}
            >
              <div className="comboCourses-inner-wrapper">
                <div className="comboCourses-content-and-btn-wrapper">
                  <h3 style={{ textAlign: "left" }}>Description</h3>
                  <div className="comboCourses-content-wrapper">
                    <div className="comboCourses-content">
                      <div className="comboCourses-heading">
                        {isExpanded ? description : truncatedDescription}
                        {description.length > 220 && (
                          <button
                            className="view-more-btn"
                            onClick={() => setIsExpanded(!isExpanded)}
                          >
                            {isExpanded ? "View Less" : "View More"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Render>

            <Render if={!!comboCoursesData?.orientation_video}>
              <div className="video-inner-wrapper">
                <div className="video-content-and-btn-wrapper">
                  <h3>Orientation Video</h3>
                </div>
                <div style={{ width: "100%", height: "300px" }}>
                  <VideoDrmPlayer
                    id_video={comboCoursesData?.orientation_video}
                  />
                </div>
              </div>
            </Render>
            <Render
              if={
                comboCoursesData?.PackageInstallmentDetails?.course_benefits
                  ?.length > 0
              }
            >
              <div className="course-benefits-inner-wrapper">
                <h3>Course Benefits</h3>
                <div className="course-benefits-list">
                  {comboCoursesData?.PackageInstallmentDetails?.course_benefits?.map(
                    (benefit, index) => (
                      <div key={index} className="course-benefit-item">
                        <img
                          src={benefit.icon}
                          alt={benefit.name}
                          className="benefit-icon"
                        />
                        <span className="course-benefit-name">
                          {benefit.name}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            </Render>

            <div className="performance-inner-wrapper">
              <div className="performance-benefits-list">
                <div className="performance-benefit-item">
                  <img
                    src={images?.learningPerformance}
                    alt="learningPerformance"
                    className="benefit-icon"
                  />
                  <span className="performance-benefit-name">
                    Improve Your Overall Learning Performance
                  </span>
                </div>
              </div>
            </div>
            <Render if={comboCoursesData?.faculty_list?.length > 0}>
              <div className="faculty-details-inner-wrapper">
                <h3>Faculty details</h3>
                <Slider {...settings}>
                  {comboCoursesData?.faculty_list?.map((faculty) => (
                    <div key={faculty?.user_id} className="faculty-slide">
                      <div
                        style={{
                          backgroundColor: "#F6F8F8",
                          padding: "15px",
                          width: "136px",
                          height: "200px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="faculty-image">
                          <img src={faculty?.thumnail} alt={faculty?.name} />
                        </div>
                        <div className="faculty-name">By {faculty?.name}</div>
                        <div className="view-more">
                          <button>View more</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Render>
            <Render if={comboCoursesData?.other_details?.length > 0}>
              <div className="other-details-inner-wrapper">
                <h3>Other details</h3>
                <ul>
                  {comboCoursesData?.other_details?.map((item, index) => (
                    <li key={index}>{item.name}</li>
                  ))}
                </ul>
              </div>
            </Render>
            <Render if={comboCoursesData?.faq?.length > 0}>
              <div className="faq-inner-wrapper">
                <h3>FAQ's (Frequently asked questions)</h3>
                <Accordion className="faq-accordion">
                  {comboCoursesData?.faq?.map((faq, index) => (
                    <Accordion.Item key={index} eventKey={index.toString()}>
                      <Accordion.Header>{faq.name}</Accordion.Header>
                      <Accordion.Body>{faq.description}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Render>
          </>
        )}

        {active === "subjects" && (
          <div className="login-subject-tab-container">
            {comboCoursesData?.subject?.map((sub) => (
              <div
                key={sub.sub_id}
                className="single-sub"
                style={{ background: sub.color }}
                onClick={() => setSubjectData(sub)}
              >
                <div className="sub-content">
                  <img
                    className="sub-image"
                    src={sub.icon}
                    alt="subject icon"
                  />
                  <div>
                    <div className="subname">{sub.subject_name}</div>
                    <div className="subtopics">{sub.total_topics} topics</div>
                  </div>
                </div>
                <img
                  className="arrw-image"
                  src={images.storeRightArrow}
                  alt="arrow"
                />
              </div>
            ))}
          </div>
        )}
      </Fragment>
    </CustomModal>
  );
};

export default ComboCourses;
